import { render } from "./dev.vue?vue&type=template&id=43277a48"
import script from "./dev.vue?vue&type=script&lang=js"
export * from "./dev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__